export default __webpack_public_path__ + "./images/masterCard-small.ec10ea1e.svg";